/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BranchGroupWithNetSalesAndOrderCount } from './BranchGroupWithNetSalesAndOrderCount';
import {
    BranchGroupWithNetSalesAndOrderCountFromJSON,
    BranchGroupWithNetSalesAndOrderCountFromJSONTyped,
    BranchGroupWithNetSalesAndOrderCountToJSON,
    BranchGroupWithNetSalesAndOrderCountToJSONTyped,
} from './BranchGroupWithNetSalesAndOrderCount';

/**
 * 
 * @export
 * @interface BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTagResponse
 */
export interface BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTagResponse {
    /**
     * 
     * @type {Array<BranchGroupWithNetSalesAndOrderCount>}
     * @memberof BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTagResponse
     */
    data: Array<BranchGroupWithNetSalesAndOrderCount>;
}

/**
 * Check if a given object implements the BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTagResponse interface.
 */
export function instanceOfBusinessReportBranchesWithNetSalesAndOrderCountPerOrderTagResponse(value: object): value is BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTagResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTagResponseFromJSON(json: any): BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTagResponse {
    return BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTagResponseFromJSONTyped(json, false);
}

export function BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTagResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTagResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(BranchGroupWithNetSalesAndOrderCountFromJSON)),
    };
}

export function BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTagResponseToJSON(json: any): BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTagResponse {
    return BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTagResponseToJSONTyped(json, false);
}

export function BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTagResponseToJSONTyped(value?: BusinessReportBranchesWithNetSalesAndOrderCountPerOrderTagResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(BranchGroupWithNetSalesAndOrderCountToJSON)),
    };
}

